import {
  selectIsAuthenticated,
  selectIsGuest,
  selectSession,
} from '../store/slices/sessionSlice'
import { useAppSelector } from './useAppSelector'

export function useSession() {
  const session = useAppSelector(selectSession)
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const isGuest = useAppSelector(selectIsGuest)

  return {
    session,
    isAuthenticated,
    isGuest,
  }
}
